import { SUBSCRIPTION_CANCEL_SUCCESS } from './types';

import { actions as modalsActions } from '../modals';
import { CANCEL_SUBSCRIPTION_CONFIRMATION } from '../../modal/types';

export default ({ dispatch }) => next => (action) => {
    const { type, payload, meta } = action;
    const actionOfType = lookedFor => type === lookedFor;

    if (actionOfType(SUBSCRIPTION_CANCEL_SUCCESS)) {
        if (meta?.skipConfirmationModal) return next(action);

        dispatch(modalsActions.showModal(CANCEL_SUBSCRIPTION_CONFIRMATION, {
            subscriptionData: payload.data.subscriptionsToUpdate[payload.data.subscriptionsToUpdate.length - 1],
        }));
    }

    return next(action);
};
